const carouselContextKey = Symbol("carouselContextKey");
const CAROUSEL_ITEM_NAME = "ElCarouselItem";

export { CAROUSEL_ITEM_NAME, carouselContextKey };
//# sourceMappingURL=constants.mjs.map
